module.exports = __webpack_public_path__ + "static/media/4_r_Layer4_90.68_0.62c89b1c.png";